import React from 'react'

function Footer() {
  return (
    <footer className=''>
      <p>Designed and developed with <span>❤</span></p>
      <div className="flex">
        <hr />
        <p>By </p>
        <b>Kishan</b>
      </div>
    </footer>
  )
}

export default Footer